import { createContext, useState } from "react";

export const AppContext = createContext({});


const ContextProvider = ({children}) => {
    const [loading, setLoading] = useState(false);   
    const [ menuAberto, setMenuAberto] = useState(false);      
    const [user, setUser] = "";//useState(localStorage.getItem(""));  
    
    const [ ctx_enc_status, set_ctx_enc_status ] = useState([]);
    const [ ctx_cad_grupos, set_ctx_cad_grupos ] = useState([]);

    
    // retorna o que esta dentro do app.jsx
    return (
        <AppContext.Provider value={{signed: !!user, loading, 
            user, setUser, menuAberto, setMenuAberto, 
            ctx_enc_status, set_ctx_enc_status,
            ctx_cad_grupos, set_ctx_cad_grupos,
        
        }}>
             {children}
        </AppContext.Provider>

    )
}

export default ContextProvider;

